const fillServerErrors = require('../../../common/components/servererrorfiller');

function SecureUserAccountForm($state, $sce, loginService, resetPasswordService, passwordValidationService) {
    return {
        restrict: 'E',
        template: require('./secure-user-account-form-template.html').trim(),
        scope: {},
        link(scope) {
            scope.loading = false;
            scope.redirect = $state.params.redirect;
            scope.passwordReset = {
                password: null,
                confirmPassword: null
            };
            scope.passwordPatternError = passwordValidationService.passwordPatternError;
            scope.passwordHint = passwordValidationService.passwordHint;
            scope.htmlTooltip = $sce.trustAsHtml(scope.passwordHint);
            scope.passwordPattern = passwordValidationService.getPattern();

            scope.onUpdatePassword = function () {
                scope.loading = true;
                resetPasswordService
                    .changePassword({
                        CurrentPassword: scope.passwordReset.currentPassword,
                        NewPassword: scope.passwordReset.newPassword
                    })
                    .then(function (response) {
                        scope.loading = false;
                        if (response.Success) {
                            $state.go('shop.secureaccount.confirmation', {
                                redirect: scope.redirect
                            });
                        } else {
                            scope.handleErrors(response.data.ResponseStatus.Errors);
                        }
                    })
                    .catch(function (response) {
                        scope.loading = false;
                        scope.handleErrors(response.data.ResponseStatus.Errors);
                    });
            };

            scope.onLogout = function () {
                loginService.logout();
            };

            scope.handleErrors = function (errors) {
                scope.serverErrors = {};
                fillServerErrors.fillForm(scope.secureUserAccountForm, errors, scope);
            };
        }
    };
}

module.exports = SecureUserAccountForm;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/secure-user-account/secure-user-account-form-directive.js
 **/